
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

interface ITdNumber {
    slot: string,
    key: string,
    sup?: string,
    format?: string,
    digits?: number,
    currency?: string,
    currencySymbol?: boolean,
    isMono?: boolean,
    // не подставлять 0.00 вместо пустого значения: null и undefined выводятся пустой ячейкой
    isEmptyIfNull?: boolean,
}

const catalogue = namespace('catalogueModule');

@Component({
    components: { },
})
export default class TdNumber extends Vue {
    @catalogue.Getter('GET_CURRENT_CURRENCY_ICON') currencySymbol;
    @Prop({ required: true }) item!: Object | any;
    @Prop({ required: true }) number!: ITdNumber;

    get getFormattedNumber(): string {
        const num = this.number.sup ? this.item[this.number.sup][this.number.key] : this.item[this.number.key];
        if (this.number.isEmptyIfNull && (num === null || num === undefined || num === '')) return '';
        return num ? Number(num).toLocaleString('ru-RU', {
            maximumFractionDigits: this.number.digits ?? 2,
            minimumFractionDigits: this.number.digits ?? 2,
        }) : `0${this.number.digits === 0 ? '' : '.'}${'0'.repeat(this.number.digits ?? 2)}`;
    }
}
